<template>
    <div class="card-container">
        <el-card class="box-card">
            <div class="flex-row vertical-center flow-justify">
                <el-button type="default" class="button-size-back" @click="handleFront"
                >返回上一级
                </el-button
                >
            </div>
            <div class="user-box flex-row vertical-center flow-justify flow-wrap">
                <div
                    style="margin-bottom: 15px"
                    class="user-left flex-row vertical-center"
                >
                    <div
                        class="user-head"
                        :style="
              'background: url(' +
              userInfo.iconUrl +
              ') center/cover no-repeat;'
            "
                    ></div>
                    <div class="flex-col around-justify">
                        <p class="user-name">
                            {{ userInfo.realName || userInfo.nickName || "未命名" }}
                        </p>
                        <p class="user-name">ID：{{ userInfo.id }}</p>
                        <p class="user-tel">{{ userInfo.phoneNumber }}</p>
                    </div>
                    <div class="flex-col around-justify">
                        <div class="flex-row flow-wrap flex-1">
                            <div class="flex-col around-justify user-msg">
                                <p class="user-title">账户余额</p>
                                <p class="user-value">
                                    ￥{{
                                    toDoubleThousands((zhanghu.withdrawSum * 100) / 10000) || 0
                                    }}
                                </p>
                            </div>
                            <div class="flex-col around-justify user-msg">
                                <p class="user-title">银盛电签积分</p>
                                <p class="user-value">{{ zhanghu.integralSum || 0 }}</p>
                            </div>
                            <div class="flex-col around-justify user-msg">
                                <p class="user-title">银盛大POS积分</p>
                                <p class="user-value">{{ zhanghu.integralYsbigSum || 0 }}</p>
                            </div>
                            <div class="flex-col around-justify user-msg">
                                <p class="user-title">其他账户余额</p>
                                <p class="user-value">
                                    {{ toDoubleThousands((zhanghu.otherSum * 100) / 10000) || 0 }}
                                </p>
                            </div>
                            <!-- <div class="flex-col around-justify user-msg">
                                <p class="user-title">活动账户余额</p>
                                <p class="user-value">
                                    {{ toDoubleThousands((zhanghu.activitySum * 100) / 10000) || 0 }}
                                </p>
                            </div> -->
                            <!-- <div class="flex-col around-justify user-msg">
                                <p class="user-title">生态账户余额</p>
                                <p class="user-value">
                                    {{ toDoubleThousands((zhanghu.ecologySum * 100) / 10000) || 0 }}
                                </p>
                            </div> -->
                            <div class="flex-col around-justify user-msg">
                                <p class="user-title">购买账户余额</p>
                                <p class="user-value">
                                    {{
                                    toDoubleThousands((zhanghu.shoppingSum * 100) / 10000) || 0
                                    }}
                                </p>
                            </div>
                            <!-- 新增白积分和收单账户余额 -->
                               <!-- <div class="flex-col around-justify user-msg">
                                <p class="user-title">欢乐豆余额</p>
                                <p class="user-value">
                                    {{
                                    toDoubleThousands((zhanghu.acquiringSum * 100) / 10000) || 0
                                    }}
                                </p>
                            </div> -->
                               <!-- <div class="flex-col around-justify user-msg">
                                <p class="user-title">收单积分</p>
                                <p class="user-value">
                                    {{
                                    toDoubleThousands((zhanghu.whiteIntegralSum * 100) / 10000) || 0
                                    }}
                                </p>
                            </div> -->
                              <!-- <div class="flex-col around-justify user-msg">
                                <p class="user-title">真商账户余额</p>
                                <p class="user-value">
                                    {{
                                    toDoubleThousands((zhanghu.zhenshangSum * 100) / 10000) || 0
                                    }}
                                </p>
                            </div> -->
                            <!-- <div class="flex-col around-justify user-msg">
                                <p class="user-title">合伙人</p>
                                <p class="user-value">
                                    {{ userInfo.partnerLevel || "非合伙人" }}
                                </p>
                            </div> -->
                            <!-- <div class="flex-col around-justify user-msg">
                                <p class="user-title">经销商</p>
                                <p class="user-value">
                                    {{ userInfo.dealerFlag == "1" ? "经销商" :  userInfo.dealerFlag == "2" ? "超级VIP" : "否" }}
                                </p>
                            </div> -->
                            <!-- <div class="flex-col around-justify user-msg">
                                <p class="user-title">保护期</p>
                                <p class="user-value">{{ userInfo.protectTime || "" }}</p>
                            </div> -->
                            <!-- <div class="flex-col around-justify user-msg">
                                <p class="user-title">礼包等级</p>
                                <p class="user-value">{{ userInfo.giftLevel || "" }}</p>
                            </div> -->
                            <!-- <div class="flex-col around-justify user-msg">
                                <p class="user-title">礼包有效期</p>
                                <p class="user-value">{{ userInfo.giftValidityDate || "" }}</p>
                            </div> -->
                        </div>
                        <div style="display: flex; align-content: center; flex-wrap: wrap">
                            <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="enableTransferMachines"
                                    inactive-text="机具划拨"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updatePosFlag"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div>
                            <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="withdrawFlag"
                                    inactive-text="分润户提现"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updatewithdrawFlag"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div>
                            <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="otherFlag"
                                    inactive-text="其他户提现"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updateotherFlag"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div>
                            <!-- <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="activityFlag"
                                    inactive-text="活动户提现"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updateactivityFlag"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div> -->
                            <!-- <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="ecologyFlag"
                                    inactive-text="生态户提现"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updateecologyFlag"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div> -->
                            <!-- <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="studioFlag"
                                    inactive-text="工作室标识"
                                    :active-value="1"
                                    :inactive-value="0"
                                    @change="updatestudioFlag"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div> -->
                            <!-- <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="specialDealer"
                                    inactive-text="特约经销商"
                                    :active-value="1"
                                    :inactive-value="0"
                                    @change="updatespecialDealer"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div> -->
                            <!--<div-->
                                <!--class="flex-col vertical-center around-justify user-msg"-->
                                <!--style="margin-top: 15px"-->
                            <!--&gt;-->
                                <!--<el-switch-->
                                    <!--v-model="dealer"-->
                                    <!--inactive-text="经销商"-->
                                    <!--active-value="1"-->
                                    <!--inactive-value="0"-->
                                    <!--@change="updateDealer"-->
                                    <!--style="margin-right: 30px"-->
                                <!--&gt;-->
                                <!--</el-switch>-->
                            <!--</div>-->
                            <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="enableGulijin"
                                    inactive-text="鼓励金"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updateenableGulijin"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div>
                            <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="enablePseudoGain"
                                    inactive-text="伪收益"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updateenablePseudoGain"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div>
                            <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="weComFlag"
                                    inactive-text="企业微信"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updateweComFlag"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div>
                            <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="integralMoveFlag"
                                    inactive-text="积分转让"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updateintegralMoveFlag"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div>
                            <!-- 新增收单户提现开关 -->
                               <!-- <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="acquiringFlag"
                                    inactive-text="真商账户提现"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updateacquiringFlag"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div> -->
                            <!-- 新增收单专员开关 -->
                             <!-- <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="acquiringPersonnelFlag"
                                    inactive-text="收单专员"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updateacquiringPersonnelFlag"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div> -->
                               <!-- <div
                                class="flex-col vertical-center around-justify user-msg"
                                style="margin-top: 15px"
                            >
                                <el-switch
                                    v-model="customMerchantFeeFlag"
                                    inactive-text="费率开关"
                                    active-value="1"
                                    inactive-value="0"
                                    @change="updatecustomMerchantFeeFlag"
                                    style="margin-right: 30px"
                                >
                                </el-switch>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="user-right">
                    <el-button
                        type="primary"
                        class="button-size"
                        @click="openDialog(9)"
                        v-if="hasPerm('/meminfo/memLvlUp')"
                    >经销商等级
                    </el-button
                    >
                    <el-button
                        type="primary"
                        class="button-size"
                        @click="openDialog(4)"
                        v-if="hasPerm('/meminfo/memLvlUp')"
                    >代理商等级
                    </el-button
                    >
                    <el-button
                        type="primary"
                        class="button-size"
                        @click="openDialog(1)"
                        v-if="hasPerm('/meminfo/updateParentId')"
                    >变更上级
                    </el-button
                    >
                    <!-- <el-button
                        type="primary"
                        class="button-size"
                        @click="openDialog(2)"
                        v-if="hasPerm('/meminfo/updateProtectTime')"
                    >保护期变更
                    </el-button
                    > -->
                    <el-button
                        type="primary"
                        class="button-size"
                        @click="openDialog(5)"
                        v-if="hasPerm('/meminfo/updatePhone')"
                    >变更手机号
                    </el-button
                    >
                    <el-button
                        type="primary"
                        class="button-size"
                        :disabled="userInfo.auth == 0"
                        v-if="hasPerm('/meminfo/chongzhi')"
                        @click="handleDelete()"
                    >认证重置
                    </el-button>
                    <el-button
                        type="primary"
                        class="button-size"
                        :style="{ width: '150px' }"
                        v-if="hasPerm('/meminfo/gljpl')"
                        @click="openDialog(6)"
                    >鼓励金(团队批量)
                    </el-button>
                    <!-- <el-button
                        type="primary"
                        class="button-size"
                        v-if="hasPerm('/meminfo/edithhr')"
                        @click="openDialog(7)"
                    >修改合伙人
                    </el-button> -->
                    <!-- <el-button
                        type="primary"
                        class="button-size"
                        v-if="hasPerm('/meminfo/giftpack')"
                        @click="openDialog(8)"
                    >礼包调级
                    </el-button> -->
                    <span v-if="hasPerm('/meminfo/updateMemStatus')">
            <el-button
                type="warning"
                class="button-size"
                @click="openDialog(3)"
                v-if="memStatus"
            >冻结账户</el-button
            >
            <el-button
                type="primary"
                class="button-size"
                @click="handelChangeStatus"
                v-else
            >启用账户</el-button
            >
          </span>
                </div>
            </div>
        </el-card>
        <el-card class="box-card member">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                    :label="tab.label"
                    :name="tab.name"
                    v-for="(tab, index) in userTabs"
                    :key="index"
                >
                </el-tab-pane>
            </el-tabs>
            <div class="mem-container">
                <router-view></router-view>
            </div>
        </el-card>

        <form-dialog
            ref="formDialog"
            :formDialogTitle="formDialogTitle"
            :model="dialogModel"
            :submitData="dialogData"
            :dialogService="dialogService"
            @success="dialogSuccess"
            @close="dialogClose"
            @opend="dialogOpen"
            :rules="dialogRules"
            class="over"
        >
            <div v-if="dialogType == 1">
                <div class="flex-row vertical-center msgbox">
                    <p>当前上级为：</p>
                    <p>{{ parentInfo.firstPhoneNumber }}</p>
                </div>
                <el-form-item prop="parentId">
                    <el-input
                        v-model="dialogModel.parentId"
                        placeholder="请输入要变更的直接上的代理商ID"
                    ></el-input>
                </el-form-item>
                <p class="notice">变更上级后，当前旗下所有同时随之变更</p>
            </div>
            <div
                style="display: flex; justify-content: center"
                v-if="dialogType == 2"
            >
                <el-date-picker
                    v-model="dialogModel.protectTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                >
                </el-date-picker>
            </div>
            <div v-else-if="dialogType == 3">
                <el-form-item prop="content">
                    <el-radio-group v-model="dialogModel.forzen">
                        <el-radio :label="0">冻结，不可登录</el-radio>
                        <!-- <el-radio :label="2">冻结，可登录不可提现</el-radio> -->
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="remark">
                    <el-input
                        v-model="dialogModel.remark"
                        placeholder="请输入冻结备注"
                    ></el-input>
                </el-form-item>
            </div>
            <div v-else-if="dialogType == 4">
                <div class="flex-row vertical-center msgbox">
                    <p>当前角色等级：</p>
                    <p>{{ userInfo.levelName }}</p>
                </div>
                <el-form-item prop="upperId">
                    <el-select v-model="dialogModel.level" @change="changeSelect">
                        <el-option
                            v-for="item in seatList"
                            :key="item.id"
                            :label="item.levelName"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-radio-group v-model="dialogModel.type" class="flex-col">
                  <el-radio :label="1">取配置</el-radio>
                  <el-radio
                    :label="2"
                    class="flex-row vertical-center"
                    style="margin-top: 20px"
                    v-if="showLimitDay"
                  >
                    <el-form-item
                      label="有效期"
                      class="validitylable"
                      style="margin-bottom: 0"
                    >
                      <div class="flex-row vertical-center flow-justify">
                        <el-input
                          type="number"
                          placeholder="请输入有效期"
                          class="input-number-limit"
                          :disabled="dialogModel.type != 2"
                          :min="0"
                          :max="999999"
                          v-model="dialogModel.validityNumber"
                          style="width: 150px"
                        ></el-input>
                        <p class="unit">天</p>
                      </div>
                    </el-form-item>
                  </el-radio>
                </el-radio-group> -->
            </div>
            <div v-else-if="dialogType == 9">
                <div class="flex-row vertical-center msgbox">
                    <p>当前等级：</p>
                    <p>{{ userInfo.dealerFlag == 1 ? '经销商' : userInfo.dealerFlag == 2 ? '超级VIP' : '--' }}</p>
                </div>
                <el-form-item prop="upperId">
                    <el-select v-model="dialogModel.dealerFlag" @change="changeSelect">
                        <el-option
                            v-for="item in dealerList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-radio-group v-model="dialogModel.type" class="flex-col">
                  <el-radio :label="1">取配置</el-radio>
                  <el-radio
                    :label="2"
                    class="flex-row vertical-center"
                    style="margin-top: 20px"
                    v-if="showLimitDay"
                  >
                    <el-form-item
                      label="有效期"
                      class="validitylable"
                      style="margin-bottom: 0"
                    >
                      <div class="flex-row vertical-center flow-justify">
                        <el-input
                          type="number"
                          placeholder="请输入有效期"
                          class="input-number-limit"
                          :disabled="dialogModel.type != 2"
                          :min="0"
                          :max="999999"
                          v-model="dialogModel.validityNumber"
                          style="width: 150px"
                        ></el-input>
                        <p class="unit">天</p>
                      </div>
                    </el-form-item>
                  </el-radio>
                </el-radio-group> -->
            </div>
            <div v-else-if="dialogType == 6">
                <el-form-item prop="enablePLGulijin">
                    <el-radio-group v-model="enablePLGulijin">
                        <el-radio label="0">否</el-radio>
                        <el-radio label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <div v-if="dialogType == 7">
                <el-form-item prop="partnerLevel">
                    <el-select v-model="dialogModel.partnerLevel">
                        <el-option
                            v-for="item in partnerLevelList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div v-if="dialogType == 8">
                <el-form-item prop="giftId">
                    <el-select v-model="dialogModel.giftId">
                        <el-option
                            v-for="item in giftIdList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div v-if="dialogType == 5">
                <el-form-item prop="phoneNumber">
                    <el-input
                        type="text"
                        v-model="phoneNumber"
                        placeholder="请输入要变更手机号"
                        maxlength="11"
                        show-word-limit
                    ></el-input>
                </el-form-item>
            </div>
        </form-dialog>
    </div>
</template>

<script>
    import FormDialog from "../../dialog/FormDialog";

    import MallService from "service/MallService";
    import OrganService from "service/OrganService";
    import MemberService from "service/MemberService";
    import ShopService from "service/ShopService";
    import MemberLevelService from "service/MemberLevelService";
    import Regs from "common/conf/Regs";

    import StorageService from "store/interfaces";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters, mapActions} from "vuex";

    export default {
        name: "memberbasicinfo",
        data() {
            return {
                userInfo: {
                    headUrl: "http://pic41.nipic.com/20140508/18609517_112216473140_2.jpg",
                },
                activeName: "basicinfo",
                userTabs: [
                    {
                        label: "基本信息",
                        name: "basicinfo",
                    },
                    {
                        label: "卡片信息",
                        name: "cardinfo",
                    },
                    // {
                    //   label: "人证数据",
                    //   name: "authdata",
                    // },
                    // {
                    //   label: "认证日志",
                    //   name: "certification",
                    // },
                    {
                        label: "签约明细",
                        name: "zhifucertification",
                    },
                    // {
                    //   label: "积分信息",
                    //   name: "integralinfo",
                    // },
                ],
                formDialogTitle: "",
                dialogModel: {
                    dealerFlag: "",
                    parentId: "",
                    forzen: 1,
                    remark: "",

                    level: "",
                    forzen: 1,
                    // validityNumber: "",
                    // type: 1,

                    partnerLevel: "",

                    protectTime: "",
                },
                dialogRules: {
                    phoneNumber: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (!this.phoneNumber) {
                                    callback(new Error("请输入电话号码"));
                                } else if (!Regs.phone.test(this.phoneNumber)) {
                                    callback(new Error("请输入正确的11位手机号码"));
                                } else {
                                    callback();
                                }
                            },
                        },
                    ],
                    enablePLGulijin: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (!this.enablePLGulijin) {
                                    callback(new Error("请选择"));
                                } else {
                                    callback();
                                }
                            },
                        },
                    ],
                    partnerLevel: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (!value) {
                                    callback(new Error("请选择"));
                                } else {
                                    callback();
                                }
                            },
                        },
                    ],
                    giftId: [
                        {
                            required: true,
                            message: "请选择",
                        },
                    ],
                },
                phoneNumber: "",
                dialogType: "",
                // showLimitDay: true,
                seatList: [],
                partnerLevelList: [
                    {
                        id: "0",
                        name: "非合伙人",
                    },
                    {
                        id: "1",
                        name: "初级合伙人",
                    },
                    {
                        id: "2",
                        name: "中级合伙人",
                    },
                    {
                        id: "3",
                        name: "高级非合伙人",
                    },
                ],
                dealerList: [{
                    id: '0',
                    name: '取消资格'
                },{
                    id: '1',
                    name: '经销商'
                },{
                    id: '2',
                    name: '超级VIP'
                },],
                giftIdList: [],
                memberId: "",
                params: {},
                memStatus: true,
                parentInfo: {},
                zhanghu: "",
                // integralInfo: {},
                isKeep: true,
                enableTransferMachines: "0",
                withdrawFlag: "0",
                weComFlag: "0",
                integralMoveFlag: "0",
                acquiringFlag: '0',
                acquiringPersonnelFlag: '0',
                customMerchantFeeFlag: '0',
                otherFlag: "0",
                activityFlag: "0",
                ecologyFlag: "0",
                enableGulijin: "0",
                enablePseudoGain: "0",
                enablePLGulijin: "",
                studioFlag: 0,
                specialDealer: 0,
                dealer: "0",
            };
        },
        mixins: [loadMixin, dialogMixin],
        components: {
            FormDialog,
        },
        inject: ["reload"],
        computed: {
            dialogService() {
                if (this.dialogType == 1) {
                    //变更上级
                    return MemberService.updateParent;
                } else if (this.dialogType == 2) {
                    //保护期变更
                    return MemberService.updateProtectTime;
                } else if (this.dialogType == 4) {
                    //代理商等级
                    return MemberService.updateMemLevel;
                } else if (this.dialogType == 5) {
                    //变更手机号
                    return MemberService.posjijuStatus;
                } else if (this.dialogType == 6) {
                    //鼓励金(批量)
                    return MemberService.plGulijin;
                } else if (this.dialogType == 7) {
                    //修改合伙人
                    return MemberService.posjijuStatus;
                } else if (this.dialogType == 8) {
                    //礼包调级
                    return MemberService.agentgift;
                }  else if (this.dialogType == 9) {
                    //礼包调级
                    return MemberService.upDealer;
                } else {
                    //冻结账户 编号3
                    return MemberService.updateMemStatus;
                }
            },
            dialogData() {
                this.params = {
                    id: this.$route.params.id,
                    tatSimpleId: this.$route.params.simpleTatId,
                    simpleTatId: this.$route.params.simpleTatId,
                };
                if (this.dialogType == 1) {
                    //变更上级
                    this.params.parentId = this.dialogModel.parentId;
                } else if (this.dialogType == 2) {
                    //保护期变更
                    this.params.userId = this.$route.params.id;
                    this.params.protectTime = this.dialogModel.protectTime;
                } else if (this.dialogType == 4) {
                    //代理商等级
                    this.params.memId = this.$route.params.id;
                    this.params.endTime = "2119-01-01";
                    this.params.isRakeBack = "0";
                    this.params.lvlManageId = this.dialogModel.level;
                    // this.params.type = this.dialogModel.type;
                    // this.params.validityNumber = this.dialogModel.validityNumber;
                } else if (this.dialogType == 5) {
                    //代理商等级
                    this.params.memId = this.$route.params.id;
                    this.params.column = "phoneNumber";
                    this.params.status = this.phoneNumber;
                    delete this.params.id;
                    delete this.params.tatSimpleId;
                    delete this.params.simpleTatId;
                } else if (this.dialogType == 6) {
                    //鼓励金批量
                    this.params.memId = this.$route.params.id;
                    this.params.column = "enableGulijin";
                    this.params.status = this.enablePLGulijin;
                    delete this.params.id;
                    delete this.params.tatSimpleId;
                    delete this.params.simpleTatId;
                } else if (this.dialogType == 7) {
                    //修改合伙人
                    this.params.memId = this.$route.params.id;
                    this.params.column = "partnerLevel";
                    this.params.status = this.dialogModel.partnerLevel;
                    delete this.params.id;
                    delete this.params.tatSimpleId;
                    delete this.params.simpleTatId;
                } else if (this.dialogType == 8) {
                    //礼包调级
                    this.params.userId = this.$route.params.id;
                    this.params.giftId = this.dialogModel.giftId;
                    delete this.params.id;
                    delete this.params.tatSimpleId;
                    delete this.params.simpleTatId;
                }else if (this.dialogType == 9) {
                    this.params.userId = this.memberId;
                    this.params.dealerFlag = this.dialogModel.dealerFlag;
                    delete this.params.id;
                    delete this.params.tatSimpleId;
                    delete this.params.simpleTatId;
                } else {
                    //冻结账户 编号3
                    this.params.memStatus = this.dialogModel.forzen;
                    this.params.remark = this.dialogModel.remark;
                }
                return this.params;
            },
            commonParams() {
                const params = {
                    id: this.memberId,
                    simpleTatId: this.$route.params.simpleTatId,
                };
                return params;
            },
            ...mapGetters([
                "serverType",
                "tatId",
                "userId",
                "innerTabBar",
                "currentOrgDetail",
                "tabBar",
            ]),
        },
        created() {
        },
        mounted() {
            this.setBasicInfoFlag(true);
            if (this.innerTabBar) {
                this.activeName = this.innerTabBar;
            }
            this.memberId = this.$route.params.id;
            this.getDetail();
            this.getgiftId();
            // this.getIntegralInfo();
        },
        watch: {
            basicInfoFlag: {
                handler(val, oldVal) {
                    if (val) {
                        this.setBasicInfoFlag(false);
                    }
                },
            },
        },
        methods: {
            reloadInfo() {
                if (this.innerTabBar) {
                    this.activeName = this.innerTabBar;
                }
                this.memberId = this.$route.params.id;
                this.getDetail();
                // this.getIntegralInfo();
            },
            // getIntegralInfo() {
            //   this.doLoad(
            //     MallService.memIntegralInfo,
            //     {
            //       memId: this.$route.params.id,
            //     },
            //     (res) => {
            //       this.doCheck(res, (res) => {
            //         this.integralInfo = res.contents;
            //       });
            //     },
            //     "信息获取失败"
            //   );
            // },
            handleClick(tab, event) {
                this.$router.replace({
                    name: tab.name,
                });
                this.activeName = tab.name;

                this.setInnerTabBar(this.activeName);
            },
            openDialog(type) {
                switch (type) {
                    case 1:
                        this.formDialogTitle = "变更上级";
                        break;
                    case 2:
                        this.formDialogTitle = "保护期变更";
                        break;
                    case 3:
                        this.formDialogTitle = "是否冻结该用户？";
                        break;
                    case 4:
                        this.formDialogTitle = "代理商升降级";
                        break;
                    case 5:
                        this.formDialogTitle = "变更手机号";
                        break;
                    case 6:
                        this.formDialogTitle = "鼓励金(团队批量)";
                        break;
                    case 7:
                        this.formDialogTitle = "修改合伙人";
                        break;
                    case 8:
                        this.formDialogTitle = "礼包调级";
                        break;
                    case 9:
                        this.formDialogTitle = "经销商等级";
                        break;
                    default:
                        break;
                }
                this.phoneNumber = this.userInfo.phoneNumber;
                this.dialogType = type;
                this.$refs.formDialog.open();
            },
            handleDelete(item) {
                this.showConfirm("是否重置？")
                    .then(() => {
                        this.doDelete(this.memberId);
                    })
                    .catch(() => {
                    });
            },
            doDelete(id) {
                this.doLoad(
                    MemberService.chongzhi,
                    {
                        memId: id,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                            this.getDetail();
                            this.reload();
                            this.setBasicInfoFlag(true);
                        });
                    },
                    "操作失败"
                );
            },
            dialogSuccess(res) {
                this.doCheck(res, (res) => {
                    if (res.respCode == "0000") {
                        this.showSuccess(res.respMsg);
                        this.$refs.formDialog.closeDialog();
                        this.getDetail();
                        this.reload();
                        this.setBasicInfoFlag(true);
                    } else {
                        this.showError(res.respMsg);
                    }
                });
            },
            dialogClose() {
                this.dialogModel = {
                    parentId: "",
                    forzen: 1,
                    remark: "",
                    content: "",

                    level: "",
                    // type: 1,
                    // validityNumber: "",

                    protectTime: "",
                };
                this.phoneNumber = "";
                this.enablePLGulijin = "";
                this.setBasicInfoFlag(false);
            },
            dialogOpen() {
                if (this.dialogType == 4) {
                    this.getSeatList();
                    return;
                }
            },
            changeSelect(val) {
                // this.showLimitDay = true;
                // this.seatList.forEach((item) => {
                //   if (item.id == val && item.parentId == 0) {
                //     this.showLimitDay = false;
                //   }
                // });
            },
            getSeatList() {
                this.doLoad(
                    OrganService.memberupgradeList,
                    {
                        tatSimpleId: this.$route.params.simpleTatId,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            const result = res.contents;
                            this.seatList = result.rows;
                        });
                    },
                    "信息获取失败"
                );
            },
            getDetail() {
                this.doLoad(
                    MemberService.selectOne,
                    this.commonParams,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.userInfo = res.contents.memInfo;
                            this.parentInfo = res.contents.parentInfo;
                            this.memStatus = this.userInfo.memStatus == 1 ? true : false;
                            this.zhanghu = res.contents;
                            this.enableTransferMachines =
                                this.userInfo.enableTransferMachines == 1 ? "1" : "0";
                            this.withdrawFlag = this.userInfo.withdrawFlag == 1 ? "1" : "0";
                            this.weComFlag = this.userInfo.weComFlag == 1 ? "1" : "0";
                            this.integralMoveFlag =
                                this.userInfo.integralMoveFlag == 1 ? "1" : "0";
                            this.acquiringFlag = this.userInfo.acquiringFlag == 1 ? '1' : '0';
                            this.acquiringPersonnelFlag = this.userInfo.acquiringPersonnelFlag == 1 ? '1' : '0'
                            this.customMerchantFeeFlag = this.userInfo.customMerchantFeeFlag == 1 ? '1' : '0'
                            this.otherFlag = this.userInfo.otherFlag == 1 ? "1" : "0";
                            this.activityFlag = this.userInfo.activityFlag == 1 ? "1" : "0";
                            this.ecologyFlag = this.userInfo.ecologyFlag == 1 ? "1" : "0";
                            this.enableGulijin = this.userInfo.enableGulijin == 1 ? "1" : "0";
                            this.enablePseudoGain =
                                this.userInfo.enablePseudoGain == 1 ? "1" : "0";
                            this.studioFlag = this.userInfo.studioFlag == 1 ? 1 : 0;
                            this.specialDealer = this.userInfo.specialDealerFlag == 1 ? 1 : 0;
                            this.dealer = this.userInfo.dealerFlag;
                            if (
                                this.userInfo.giftLevel == "0" ||
                                this.userInfo.giftLevel == ""
                            ) {
                                return (this.userInfo.giftLevel = "");
                            } else {
                                return (this.userInfo.giftLevel = this.giftIdList.find(
                                    (item) => item.giftLevel == this.userInfo.giftLevel
                                ).name);
                            }
                        });
                    },
                    "信息获取失败"
                );
            },
            handelChangeStatus() {
                this.dialogType == 3;
                this.showConfirm("是否启用？")
                    .then(() => {
                        this.doLoad(
                            MemberService.updateMemStatus,
                            this.dialogData,
                            (res) => {
                                this.doCheck(res, (res) => {
                                    this.showSuccess(res.respMsg);
                                    this.getDetail();
                                    this.reload();
                                });
                            },
                            "信息获取失败"
                        );
                    })
                    .catch(() => {
                    });
            },
            updatePosFlag(val) {
                //机具划拨
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "enableTransferMachines",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            updatewithdrawFlag(val) {
                //分润户提现
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "withdrawFlag",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            updateweComFlag(val) {
                //企业微信
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "weComFlag",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            updateintegralMoveFlag(val) {
                //积分转让
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "integralMoveFlag",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
             updateacquiringFlag(val) {
                //收单户提现
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "acquiringFlag",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
             updateacquiringPersonnelFlag(val) {
                //收单专员
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "acquiringPersonnelFlag",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            updatecustomMerchantFeeFlag(val) {
                //费率开关
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "customMerchantFeeFlag",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            updateotherFlag(val) {
                //其他户提现
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "otherFlag",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            updateactivityFlag(val) {
                //其他户提现
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "activityFlag",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            updateecologyFlag(val) {
                //其他户提现
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "ecologyFlag",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            updateenableGulijin(val) {
                //鼓励金
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "enableGulijin",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            updateenablePseudoGain(val) {
                //伪收益
                this.doLoad(
                    MemberService.posjijuStatus,
                    {
                        status: val,
                        memId: this.memberId,
                        column: "enablePseudoGain",
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            updatestudioFlag(val) {
                //工作室
                this.doLoad(
                    MemberService.studioSwitch,
                    {
                        studioFlag: val,
                        userId: this.memberId,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            updatespecialDealer(val) {
                //特约代理商
                this.doLoad(
                    MemberService.upspecialDealer,
                    {
                        specialDealer: val,
                        userId: this.memberId,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                            this.getDetail();
                            // this.reload();
                        });
                    },
                    "信息获取失败",
                    (error) => {
                        // this.getDetail();
                        if (error.data.respCode == "9999") {
                            this.specialDealer = 0;
                        }
                    }
                );
            },
            updateDealer(val) {
                //经销商
                this.doLoad(
                    MemberService.upDealer,
                    {
                        dealerFlag: val,
                        userId: this.memberId,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.showSuccess(res.respMsg);
                            this.getDetail();
                            // this.reload();
                        });
                    },
                    "信息获取失败",
                    (error) => {
                    }
                );
            },
            getgiftId() {
                this.doLoad(
                    ShopService.giftpackmanageList,
                    {
                        size: 9999,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.giftIdList = res.contents.rows;
                        });
                    },
                    "信息获取失败"
                );
            },
            handleFront() {
                this.$router.push({
                    name: "organuser",
                });
                this.setBasicInfoFlag(false);
            },
            ...mapActions({
                setInnerTabBar: StorageService.TabBar.setInnerTabBar,
                // setCurrentOrgDetail: StorageService.Page.currentOrgDetail,
                setAlivePage: StorageService.AlivePage.setAlivePage,
                setTabBar: StorageService.TabBar.setTabBar,
                setBasicInfoFlag: StorageService.Reload.basicInfoFlag,
            }),
        },
    };
</script>

<style scoped>
    .button-size-back {
        width: 120px;
        margin-bottom: 30px;
    }

    .card-container {
        background: transparent;
        box-shadow: none;
        padding: 0;
    }

    .unit {
        margin-left: 10px;
        color: #aaaaaa;
        word-break: keep-all;
    }

    .button-size {
        width: 110px;
        height: 40px;
        margin: 0px 10px 10px 0px !important;
    }

    .user-head {
        min-width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 14px;
        border: 1px solid #dddddd;
    }

    .user-name {
        font-size: 16px;
        color: rgba(7, 154, 222, 1);
    }

    .user-tel {
        font-size: 14px;
        color: rgba(170, 170, 170, 1);
    }

    .user-msg {
        margin-left: 50px;
    }

    .user-title {
        font-size: 14px;
        color: #000;
    }

    .user-value {
        font-size: 20px;
        color: #000;
        font-weight: bold;
    }

    .box-card {
        margin-bottom: 30px;
    }

    .notice {
        font-size: 14px;
        color: #ff6600;
    }

    .msgbox p {
        font-size: 14px;
        color: #000;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 1600px) {
        .user-box {
            display: block;
        }

        .user-right {
            margin-top: 20px;
        }
    }

    @media screen and (max-width: 1220px) {
        .user-msg {
            margin-left: 40px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/MemberBasicInfo.vue